import * as React from "react";
import Icon from "common/icons";

const styles = require("./emptyContent.scss");

interface IProp {
  message: React.ReactNode;
}

class EmptyContent extends React.Component<IProp> {
  public render() {
    return (
      <div className={styles.noDataWrapper}>
        <Icon icon="NO_DATA" />
        <span>{this.props.message}</span>
        {this.props.children}
      </div>
    );
  }
}
export default EmptyContent;
